import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft, faQuoteRight } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";
import ROOT_URL from "../../Utilities/apiconfig";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await axios.get(`${ROOT_URL}/api/testimonials`);
        setTestimonials(response.data);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      }
    };

    fetchTestimonials();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 3000,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div
      className="testimonial-page-section py-5"
      role="region"
      aria-labelledby="testimonials-heading"
      style={{overflowX: 'hidden',}}
    >
      {/* Helmet SEO */}
      <Helmet>
        <title>Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Patient Testimonials</title>
        <meta name="description" content="Read genuine patient testimonials and reviews for Columbiaa Hospital, Kasturi Nagar, Bangalore. Trusted for brain surgery, spine care, cardiology, emergency services, and compassionate healthcare. See what our patients say about our expert doctors and world-class facilities." />
        <meta name="keywords" content="patient testimonials, Columbiaa Hospital reviews, patient feedback, hospital reviews, Kasturi Nagar hospital reviews, Bangalore hospital reviews, best hospital testimonials, patient experience Columbiaa Hospital, neurosurgeon reviews, brain surgery patient review, spine surgery testimonials, cardiology patient review, best multi-speciality hospital Bangalore, top hospital Kasturi Nagar, healthcare reviews Bangalore, hospital near me, patient stories, Dr H V Satish Babu reviews, Columbiaa Hospital feedback, trusted hospital Bangalore, compassionate care testimonials, medical treatment reviews, hospital patient experience" />
        <meta name="author" content="Columbiaa Hospital" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Patient Testimonials" />
        <meta property="og:description" content="Read genuine patient testimonials and reviews for Columbiaa Hospital, Kasturi Nagar, Bangalore. Trusted for neurosurgery, cardiology, and compassionate healthcare." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:locale" content="en_IN" />
        <link rel="canonical" href="https://columbiaahospital.com" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Columbiaa Hospital",
              "url": "https://columbiaahospital.com",
              "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8548979899",
                "contactType": "appointments",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi", "Kannada"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Bengaluru",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>

      {/* Section Title */}
      <div className="sec-title centred" data-aos="fade-right">
        <h2 id="testimonials-heading" style={{ fontWeight: "300" }}>
          Trusted Care at <strong>Columbiaa Hospital</strong>, Advanced
          Treatment <br />
          <span style={{ fontStyle: "italic" }}>"What Our Patients Say"</span>
        </h2>
      </div>

      <div className="auto-container">
        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <article
              key={index}
              className="testimonial-block-three py-5"
              aria-label={`Testimonial about Columbiaa Hospital by ${testimonial.name}`}
            >
              <div className="inner-box border border-success">
                <div className="author-box">
                  <figure className="author-thumb" data-aos="fade-down-right">
                    <img
                      src={`${ROOT_URL}/uploads/testimonials/${testimonial.image}`}
                      alt={`${testimonial.name}`}
                      loading="lazy"
                      width="100"
                      height="100"
                    />
                  </figure>
                  <h3 className="pt-3" data-aos="fade-down-left">
                    {testimonial.name}
                  </h3>
                  <span className="designation">{testimonial.designation}</span>
                </div>

                <blockquote
                  className="text"
                  aria-label={`Testimonial from ${testimonial.name} about Columbiaa Hospital`}
                >
                  <p>
                    <FontAwesomeIcon
                      icon={faQuoteLeft}
                      style={{
                        marginRight: "8px",
                        color: "#4CAF50",
                        fontSize: "28px",
                      }}
                    />
                    {testimonial.text}
                    <FontAwesomeIcon
                      icon={faQuoteRight}
                      style={{
                        marginLeft: "8px",
                        color: "#4CAF50",
                        fontSize: "28px",
                      }}
                    />
                  </p>
                </blockquote>
              </div>
            </article>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Testimonials;
